<template>
  <div class="d-flex flex-row align-center">
    <country-flag :country="getFlag()" size="normal" />
    <v-select
      class="select"
      dense
      :items="languageArray"
      item-text="translation"
      item-value="short"
      v-on:change="changeLanguage"
      :value="storedLanguage"
      hide-details="auto"
    >
    </v-select>
  </div>
</template>
<script>
import { languages } from '@/locales';
import { getOfficialStyle } from '@/utils/LanguageTypeConversions';
export default {
  name: 'langDropdown',
  data() {
    return {
      languageArray: Object.values(languages),
    };
  },
  methods: {
    changeLanguage(e) {
      const parsedLocale = e.split('-')[0];
      this.$store.dispatch('user/updateLocale', parsedLocale);
    },
    getFlag() {
      const language =
        this.$store.state.user.user && this.$store.state.user.user.language
          ? this.$store.state.user.user.language
          : 'en';
      switch (language) {
        case 'en': {
          return 'gb';
        }
        case 'sv': {
          return 'se';
        }
        case undefined: {
          return 'gb';
        }
        default: {
          return language;
        }
      }
    },
  },

  computed: {
    storedLanguage() {
      const language =
        this.$store.state.user.user && this.$store.state.user.user.language
          ? this.$store.state.user.user.language
          : 'en';
      return getOfficialStyle(language);
    },
  },
};
</script>

<style scoped>
.select {
  max-width: 120px;
  margin-left: 0.5rem;
}
</style>
